export interface PaginationButtonProps {
  text: string;
  state?: 'normal' | 'selected' | 'ellipsis';
  onSelect?: (ev: React.MouseEvent<HTMLDivElement>) => void;
  internalIndex?: number;
}

export const withLogic =
  (
    Component: React.ComponentType<PaginationButtonProps>
  ): React.FC<PaginationButtonProps> =>
  (props: PaginationButtonProps) => {
    return (
      <Component
        {...{
          ...props,
          _ariaCurrent: props.state === 'selected' ? 'page' : undefined
        }}
      />
    );
  };
